module.exports = __webpack_public_path__ + "img/shop-item.56006702.png";